<template>
<!-- 同一英雄ページ -->
  <div class="character">
    <WindowBox>
      <p>
        <span v-html="$t('text001', null, 'localeSameCharacters')" />
        <span v-html="$t('text002', null, 'localeSameCharacters')" />
      </p>
    </WindowBox>

    <table class="ranking-table">
      <thead>
        <tr>
          <th class="table-ranking" v-html="$t('text014', null, 'localeResult')" />
          <th class="table-name">
            <p v-html="$t('text015', null, 'localeResult')" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in sameHeroes" :key="i">
          <!-- 同一シリーズに別バージョンキャラが存在する場合 -->
          <template v-if="isSameSeries(item)">
            <td class="table-ranking" v-html="sameSeriesHeroName(item)" />
            <td class="table-name">
              <p class="table-series-name">
                <span v-html="sameSeriesSeriesName(item)" />
              </p>
            </td>
          </template>
          <!-- 異なるシリーズに同名キャラが存在する場合 -->
          <template v-else>
            <td class="table-ranking" v-html="heroName(item)" />
            <td class="table-name">
              <p class="table-series-name" v-for="(series,ii) in seriesNames(item)" :key="ii">
                <span v-html="series" />
              </p>
            </td>
          </template>
        </tr>
      </tbody>
    </table>

    <div class="nav">
      <div class="btn-nav-back" :class="[this.$route.params.lang]" @click="backToTop()" />
    </div>

    <hr class="footer-line">
  </div>
</template>

<script>
import Api from '@libraries/api/'
import RequestSameHeroes from '@requests/same-heroes-static'

import WindowBox from '@components/global/window-box.vue'

import localeSameCharacters from '@locales/sameCharacters'
import localeResult from '@locales/result'
import localeCharacter from '@locales/character'
import localeSeries from '@locales/series'

export default {
  name: 'character',
  $messages: { localeSameCharacters, localeResult },
  components: {
    WindowBox,
  },
  data() {
    return {
      sameHeroes: []
    }
  },
  created() {
    this.getSameHeroes()
  },
  watch: {
    '$route.params.lang'(){
      this.getSameHeroes()
    },
  },
  methods: {
    getSameHeroes () {
      Api.call(new RequestSameHeroes())
        .then((heroes) => {
          this.sameHeroes = heroes
        })
        .catch(({error}) => {
          throw error
        })
    },
    heroName(item) {
      return localeCharacter[this.$route.params.lang][Object.values(item)[0][0].id]
    },
    seriesNames(item) {
      return Object.values(item)[0].map((hero) => {
        const key = `game${hero.seriesId}.title`
        return localeSeries[this.$route.params.lang][key]
      })
    },
    sameSeriesHeroName(item) {
      return Object.values(item)[0].map((hero) => localeCharacter[this.$route.params.lang][hero.id]).join('<br>')
    },
    sameSeriesSeriesName(item) {
      const key = `game${Object.values(item)[0][0].seriesId}.title`
      return localeSeries[this.$route.params.lang][key]
    },
    backToTop() {
      this.$router.push({ name: 'top'})
      window.scrollTo(0, 0)
    },
    isSameSeries(item) {
      const seriesIds = Object.values(item)[0].map(hero => hero.seriesId)
      const first = seriesIds[0]
      return seriesIds.every(seriesId => seriesId === first)
    }
  },
}
</script>

<style lang="scss" scoped>
.box-outer {
  margin: 20px auto 34px;
}

.ranking-table {
  position: relative;
  width: 640px;
  margin-bottom: 30px;
  background-color: rgba(0, 0, 0, .2);
  background-image: url(#{$img-path}lin_list.png);
  background-repeat: no-repeat;
  background-position: bottom;
  border-spacing: 0;
  tr::after {
    position: absolute;
    left: 0px;
    display: block;
    width: 640px;
    height: 2px;
    background: url(#{$img-path}lin_list.png) no-repeat;
    content: '';
  }
  th, td {
    box-sizing: border-box;
    padding: 20px;
    text-align: left;
  }
  th {
    font-weight: normal;
    font-size: $fs-base;
    line-height: 1.2;
  }
  td {
    vertical-align: middle;
  }
}
.table-ranking {
  box-sizing: border-box;
  font-size: $fs-xlarge;
  text-align: center;
  width: 200px;
}
.table-name {
  box-sizing: border-box;
  font-size: $fs-xlarge;
  text-align: left;
}
.table-series-name {
  color: #878787;
  font-size: $fs-base;
}

.nav {
    display: flex;
    justify-content: center;
    position: relative;
    height: 140px;
    margin: 15px 0;
}
.btn-nav-back {
  display: block;
  @include hidden-text();
  background-repeat: no-repeat;
  background-position: left top;
  width: 108px;
  height: 112px;
  @include tap-event();
  &.ja-JP {
    background-image: url(#{$img-path}common/ja-JP/btn_back.png);
  }
  &.de-DE {
    background-image: url(#{$img-path}common/de-DE/btn_back.png);
  }
  &.en-GB {
    background-image: url(#{$img-path}common/en-GB/btn_back.png);
  }
  &.en-US {
    background-image: url(#{$img-path}common/en-US/btn_back.png);
  }
  &.es-ES {
    background-image: url(#{$img-path}common/es-ES/btn_back.png);
  }
  &.es-MX {
    background-image: url(#{$img-path}common/es-MX/btn_back.png);
  }
  &.fr-CA {
    background-image: url(#{$img-path}common/fr-CA/btn_back.png);
  }
  &.fr-FR {
    background-image: url(#{$img-path}common/fr-FR/btn_back.png);
  }
  &.it-IT {
    background-image: url(#{$img-path}common/it-IT/btn_back.png);
  }
  &.pt-BR {
    background-image: url(#{$img-path}common/pt-BR/btn_back.png);
  }
  &.zh-TW {
    background-image: url(#{$img-path}common/zh-TW/btn_back.png);
  }
}

.footer-line {
    width: 640px;
    height: 2px;
    margin: 0;
    background: url(#{$img-path}lin_list.png) center no-repeat;
    border: 0;
}

</style>
